import AppointmentFormSectionImplementation from '../implementation/sections/AppointmentFormSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiAppointmentFormSectionDTO,
  AppointmentFormSectionDTO,
} from '@lib/strapi/dtos/components/sections/appointmentFormSection.dto';

const AppointmentFormSection = (props: ComponentProps<AppointmentFormSectionDTO>) => {
  return <AppointmentFormSectionImplementation {...props}></AppointmentFormSectionImplementation>;
};

export default AppointmentFormSection;
